import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';

/*
  Generated class for the EtiquetasProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class EtiquetasProvider {
  private api: string = "";
  
  constructor(public http: Http, public global:GlobalProvider) {
    this.api = this.global.api;
    
  }

  // Elimina un congreso
  public delete(clave): Observable<any> {
   
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "etiquetas",
      "clave": clave,
    };

    return this.http.post(this.api+"apigen/delete.php", parametros, options).map(
      (response) => {
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public insert(congreso,etiqueta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    etiqueta.clavecongreso = congreso.clave;

    let parametros ={
      "token":this.global.token,
      "tabla": "etiquetas",
      "parametros": etiqueta,
      "clavecongreso":etiqueta.clavecongreso 
   //   "imagen": imagen
    };
 
    
    return this.http.post(this.api+"apigen/insert.php", parametros, options).map(
      (response) => {
        
        return response.json(); 
      }
    ).catch(this.handleError);
  }

  // Inserta un congreso nuevo
  public update(congreso,etiqueta): Observable<any> {

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    let parametros ={
      "token":this.global.token,
      "tabla": "etiquetas",
      "clave": etiqueta.clave,
      "parametros": etiqueta,
      "clavecongreso":etiqueta.clavecongreso 
    //  "imagen": imagen
    };
   
    return this.http.post(this.api+"apigen/update.php", parametros, options).map(
      (response) => {
        var respuesta = response.json();
       
       return respuesta[0];
      }
    ).catch(this.handleError);
  }


  // Devuelve todos los poenentes de un congreso
  public all(clavecongreso,tipo): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "tipo":tipo,
      "clavecongreso": clavecongreso
    };
     return this.http.post(this.api+"etiquetas/listaetiquetas.php", parametros, options).map(
      (response) => {
         
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public alletiquetaclave(clavecongreso,tipo,etiqueta): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "tipo":tipo,
      "clavecongreso": clavecongreso,
      "etiqueta": etiqueta

    };
    return this.http.post(this.api+"etiquetas/listaetiquetasclave.php", parametros, options).map(
      (response) => {
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public allponentes(clavecongreso,ponente): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    if(ponente.clave>0){

    }else{
      ponente.clave = 0;
    }
    let parametros ={
      "token":this.global.token,
      "claveponente":ponente.clave,
      "clavecongreso": clavecongreso
    };
   
    return this.http.post(this.api+"ponentes/listaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public grabaponentes(etiquetas,ponente): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "etiquetas":etiquetas,
      "claveponente":ponente.clave
    };
   
    return this.http.post(this.api+"ponentes/grabaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public grabaasistentes(etiquetas,asistente): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "etiquetas":etiquetas,
      "claveasistente":asistente.clave
    };
   
    return this.http.post(this.api+"asistentes/grabaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public grabapatrocinadores(etiquetas,patrocinador): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "etiquetas":etiquetas,
      "clavepatrocinador":patrocinador.clave
    };
   
    return this.http.post(this.api+"patrocinadores/grabaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public grabareuniones(etiquetas,reunion): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "etiquetas":etiquetas,
      "clavereunion":reunion.clave
    };
   
    return this.http.post(this.api+"reunion/grabaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public alldocumentos(clavecongreso,documento): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "clavedocumento":documento.clave,
      "clavecongreso": clavecongreso
    };
  
    return this.http.post(this.api+"documentos/listaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public grabadocumentos(etiquetas,documento): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "etiquetas":etiquetas,
      "clavedocumento":documento.clave
    };
   
    return this.http.post(this.api+"documentos/grabaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public allasistentes(clavecongreso,asistente): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    if(asistente.clave>0){

    }else{
      asistente.clave = 0;
    }
    let parametros ={
      "token":this.global.token,
      "claveasistente":asistente.clave,
      "clavecongreso": clavecongreso
    };
   
    return this.http.post(this.api+"asistentes/listaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public allreuniones(clavecongreso,reunion): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    if(reunion.clave>0){

    }else{
      reunion.clave = 0;
    }
    let parametros ={
      "token":this.global.token,
      "clavereunion":reunion.clave,
      "clavecongreso": clavecongreso
    };
   
    return this.http.post(this.api+"reunion/listaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }

  public allpatrocinadores(clavecongreso,patrocinador): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    if(patrocinador.clave>0){

    }else{
      patrocinador.clave = 0;
    }
    let parametros ={
      "token":this.global.token,
      "clavepatrocinador":patrocinador.clave,
      "clavecongreso": clavecongreso
    };
   
    return this.http.post(this.api+"patrocinadores/listaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public alleventos(clavecongreso,evento): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    if(evento.clave>0){

    }else{
      evento.clave = 0;
    }
    let parametros ={
      "token":this.global.token,
      "claveevento":evento.clave,
      "clavecongreso": clavecongreso
    };
   
    return this.http.post(this.api+"programa/listaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }

  public grabaeventos(etiquetas,evento): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "etiquetas":etiquetas,
      "claveprograma":evento.clave
    };
   
    return this.http.post(this.api+"programa/grabaetiquetas.php", parametros, options).map(
      (response) => {
        
        
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }


  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/providers/etiquetas/etiquetas.ts